const WelcomePage = () => {
  return (
    <div className="flex-1 space-y-4 p-4 sm:p-6 lg:p-8">
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">
            Welcome
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground">
            Select an option to get started.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
